var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStopped = function SvgStopped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ED1D1D",
    cx: 9.5,
    cy: 9.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 6,
    y: 6,
    width: 7,
    height: 7,
    rx: 0.5
  }))));
};

export default SvgStopped;